import { Component, Input, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { ICrumb } from '../breadcrumbs/breadcrumbs.types';

@Component({
	selector: 'rbc-hero',
	templateUrl: './hero.component.html',
	styleUrls: ['./hero.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class HeroComponent implements OnInit, OnDestroy {
	@Input() image: string;
	@Input() person: boolean = false;
	@Input() imagePosition: string = '0% 0%';
	@Input() id: string;
	@Input() imageBottom: boolean = false;
	@Input() border: boolean = false;
	@Input() center: boolean = false;
	@Input() flush: boolean = false;
	@Input() fullWidth: boolean = false;
	@Input() card: boolean = false;
	@Input() chevron: boolean = false;
	@Input() borderText: string;
	@Input() borderLink: string;
	@Input() cardPosition: string = 'left';
	@Input() avatarImage: string;
	@Input() avatarSize: string = 'large';
	@Input() avatarColor: string;
	@Input() avatarText: string;
	@Input() avatarTextColor: string;
	@Input() title: string;
	@Input() subtitle: string;
	@Input() ctaIcon: string = '';
	@Input() ctaText: string;
	@Input() ctaLink: string;
	@Input() byLine: string;
	@Input() category: string;
	@Input() categoryColor: string;
	@Input() marker: string;
	@Input() summary: string;
	@Input() breadcrumbs: ICrumb[];

	constructor(private idService: IdService) {}

	ngOnInit() {
		if (!this.id) {
			this.id = this.idService.generate();
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	bannerStyles() {
		const { image, person, imagePosition } = this;
		if (!image) {
			return;
		}

		return {
			['background-image']: `url(${image})`,
			['background-position']: person ? 'bottom right' : imagePosition,
			['background-size']: !person ? 'cover' : null
		};
	}

	bannerClasses() {
		const { border, image, center, imageBottom, borderText, flush, person } = this;
		return {
			'hero-keyline': border && image,
			'hero-center': center,
			'hero-flush': (image && imageBottom) || (border && !image && !borderText) || flush,
			'hero-person': person
		};
	}
}
